module.exports = __webpack_public_path__ + "fonts/opoli.05c307d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/opoli.eot?y08y5r
// module id = 277
// module chunks = 0